import { useEffect, useState } from 'react';
import { readStoreConsent } from '../tracking/storeConsent.js';

/** @param {string} slug */
export function useStoreConsent(slug) {
  const [consent, setConsent] = useState(() => readStoreConsent(slug));

  useEffect(() => {
    setConsent(readStoreConsent(slug));
  }, [slug]);

  useEffect(() => {
    if (!slug || typeof window === 'undefined') return undefined;
    function onStorage(ev) {
      if (ev.key === `ominia.consent.v2.${slug}`) {
        setConsent(readStoreConsent(slug));
      }
    }
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, [slug]);

  return consent;
}
